module.exports = __webpack_public_path__ + "static/jiva3-7e99c3fcbe9b4298a56151c606bae455.png";